import { QueryFilterParameter } from 'src/app/widgets/filters/models/query-filter-parameter.model';

export class MRPOverviewPram {
    Action: string;
    numofdays: string; 
    filtersOptions: QueryFilterParameter[] = [];
  }

  export class OrderOverviewPram {
    Action: string;
    numofdays: string; 
    filtersOptions: QueryFilterParameter[] = [];
  }
  